import Column from '@components/column'
import styled from '@emotion/styled'
import React, { Fragment } from 'react'

const ResultModal = ({ data }: any) => {
  const images = data?.infos?.images || []
  const hasImages = images.some((img: string) => img)
  console.log(data, 'data')
  return (
    <Fragment>
      <p>Match Results</p>
      <br />
      <p>Claimed Status: {data.claimedStatus ? data.claimedStatus : 'N/A'}</p>

      <p style={{ fontSize: '14px', color: 'gray' }}>
        Report Reason:{' '}
        {data.claimedStatus === 'Reported' ? data?.infos?.title : 'N/A'}
      </p>
      <br />
      <p style={{ fontSize: '14px', color: 'gray' }}>
        Phone No: {data?.infos?.whatsAppNo}
      </p>
      <br />
      {hasImages ? (
        images.map((img: string, index: number) =>
          img ? (
            <ImagePreview key={index}>
              <Image
                src={`https://admin.tournaop.com/${img}`}
                alt={`Result ${index}`}
              />
            </ImagePreview>
          ) : null,
        )
      ) : (
        <ImagePreview>
          <NoImageText>No Images</NoImageText>
        </ImagePreview>
      )}
      <br />
      <div>
        <p>Remarks</p>
        <br />
        <RemarkContainer>
          {data?.infos?.remark ? data?.infos?.remark : 'No Remarks'}
        </RemarkContainer>
      </div>
      <div>
        <br />
        {data.claimedStatus === 'Reported' && (
          <>
            <p>Custom Remarks</p>
            <br />
            <RemarkContainer>
              {data?.infos?.customRemarks
                ? data?.infos?.customRemarks
                : 'No Remarks'}
            </RemarkContainer>
          </>
        )}
      </div>
    </Fragment>
  )
}

export default ResultModal

export const ImagePreview = styled.div`
  width: 100%;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  border: 1px dashed #d1d1d1;
  background-color: #f9f9f9;
  margin-bottom: 20px;
`

export const Image = styled.img`
  width: 100%;
  height: 95%;
  object-fit: contain;
  border-radius: 12px;
`

export const NoImageText = styled.p`
  color: #999;
  font-size: 16px;
  font-style: italic;
`

export const RemarkContainer = styled.div`
  border: 1px solid #e9e9e9;
  border-radius: 12px;
  min-height: 200px;
  padding: 12px;
  color: #9e7171;
`
